const postJSON = async (url, payload, nonce) => {
  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-WP-Nonce': nonce || '',
    },
    credentials: 'same-origin',
    body: JSON.stringify(payload),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw data;
  return data;
};

// ✅ setText aceita tipo opcional: 'success' | 'error' | ''
const setText = (el, msg, type = '') => {
  if (!el) return;
  el.textContent = msg || '';
  el.classList.remove('pcf-status--success', 'pcf-status--error');
  if (type === 'success') el.classList.add('pcf-status--success');
  if (type === 'error')   el.classList.add('pcf-status--error');
};

const initNative = (root) => {
  const form = root.querySelector('form.pcf-form');
  const status = root.querySelector('.pcf-status');
  if (!form || !status) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    setText(status, 'A enviar...', '');

    const payload = {
      firstName: form.firstName?.value || '',
      lastName: form.lastName?.value || '',
      email: form.email?.value || '',
      mobile: form.mobile?.value || '',
      message: form.message?.value || '',
      company: form.company?.value || '',

      toEmail: root.dataset.toEmail || '',
      replyToMode: root.dataset.replytoMode || 'user',
      fromName: root.dataset.fromName || '',
      fromEmail: root.dataset.fromEmail || '',
      emailSubject: root.dataset.emailSubject || '',

      enableAutoresponder: root.dataset.autoEnabled === '1',
      autoresponderSubject: root.dataset.autoSubject || '',
      autoresponderMessage: root.dataset.autoMessage || '',
    };

    try {
      const url = root.dataset.restUrl;
      await postJSON(url, payload, root.dataset.nonce);

      setText(status, root.dataset.success || 'Enviado!', 'success');
      form.reset();
      setTimeout(() => setText(status, '', ''), 4000);
    } catch (err) {
      setText(status, root.dataset.error || 'Erro.', 'error');
      // eslint-disable-next-line no-console
      console.error('Contact form error:', err);
    }
  });
};

const initCF7 = (root) => {
  const cf7form = root.querySelector('form.wpcf7-form');
  if (!cf7form) return;

  const status = root.querySelector('.pcf-status');
  if (!status) return;

  setText(status, '', '');

  // ✅ label flutuante
  const updateFilled = (input) => {
    const box = input.closest('.inputBox');
    if (!box) return;
    if ((input.value || '').trim().length > 0) box.classList.add('pcf-filled');
    else box.classList.remove('pcf-filled');
  };

  const inputs = cf7form.querySelectorAll('input[type="text"],input[type="email"],input[type="tel"],textarea');
  inputs.forEach((el) => {
    updateFilled(el);
    el.addEventListener('input', () => updateFilled(el));
    el.addEventListener('blur', () => updateFilled(el));
  });

  const clearLater = () => setTimeout(() => setText(status, '', ''), 4000);

  // ✅ Identificar este form pelo unit tag
  const unitTag = cf7form.querySelector('input[name="_wpcf7_unit_tag"]')?.value || '';

  const isThisFormEvent = (event) => {
    if (!event) return false;
    if (event.detail?.unitTag && unitTag) return event.detail.unitTag === unitTag;
    if (event.target && event.target === cf7form) return true;
    return false;
  };

  // ✅ Antes de submeter
  document.addEventListener('wpcf7beforesubmit', (event) => {
    if (!isThisFormEvent(event)) return;
    setText(status, 'A enviar...', '');
  });

  // ✅ Validação falhou no cliente (campos vazios/inválidos)
  // Usamos wpcf7invalid em vez de wpcf7submit para evitar problemas de timing
  document.addEventListener('wpcf7invalid', (event) => {
    if (!isThisFormEvent(event)) return;
    setText(status, root.dataset.error || 'Verifica os campos obrigatórios.', 'error');
  });

  // ✅ Após submeter ao servidor
  document.addEventListener('wpcf7submit', (event) => {
    if (!isThisFormEvent(event)) return;

    const s = event.detail?.status || '';
    const msg = event.detail?.apiResponse?.message || '';

    // eslint-disable-next-line no-console
    console.log('[PCF CF7 submit]', { status: s, message: msg, detail: event.detail });

    if (s === 'mail_sent') {
      setText(status, root.dataset.success || msg || 'Enviado!', 'success');
      cf7form.reset();
      inputs.forEach((el) => updateFilled(el));
      clearLater();
      return;
    }

    if (s === 'validation_failed') {
      // ✅ tratado pelo wpcf7invalid — não fazer nada aqui
      return;
    }

    if (s === 'mail_failed') {
      setText(status, root.dataset.error || msg || 'Falha ao enviar.', 'error');
      return;
    }

    if (s === 'spam') {
      setText(status, root.dataset.error || msg || 'Spam detetado.', 'error');
      return;
    }

    // fallback
    if (msg) setText(status, msg, 'error');
    else setText(status, root.dataset.error || 'Erro.', 'error');
  });
};

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.pcf-root').forEach((root) => {
    const mode = root.dataset.mode || 'native';
    if (mode === 'cf7') initCF7(root);
    else initNative(root);
  });
});